import { gql } from "@apollo/client";

export const POST_MESSAGE = gql`
  mutation PostMessage($params: PostMessageInput!) {
    postMessage(params: $params) {
      id
      conversationId
      requestUniqueKey
      contentHtml
      contentJson
      createdAt
      updatedAt
      isOwner
      sender {
        email
        firstName
        lastName
        fullName
        avatar
        isDeleted
      }
      attachments {
        id
        messageId
        fileName
        fileDisplayName
        filePath
        fileMimeType
        fileSize
      }
    }
  }
`;
